import * as React from "react";
import { ReadOnlyFormGroup } from "components/common";
const HttpNotificationDetails = ({ notification }) => {
  var _a, _b;
  const apiKeySet = (_a = notification.config.api_secret) == null ? void 0 : _a.is_set;
  const apiSentAs = notification.config.api_key_as_header ? "Header" : "Query Parameter";
  return /* @__PURE__ */ React.createElement(React.Fragment, null, /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "URL", value: notification.config.url }), /* @__PURE__ */ React.createElement(
    ReadOnlyFormGroup,
    {
      label: "Basic Authentication",
      value: ((_b = notification.config.basic_auth) == null ? void 0 : _b.is_set) ? "******" : null
    }
  ), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "API Key/Secret Sent As", value: apiKeySet ? apiSentAs : null }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "API Key", value: notification.config.api_key }), /* @__PURE__ */ React.createElement(ReadOnlyFormGroup, { label: "API Secret", value: apiKeySet ? "******" : null }));
};
export default HttpNotificationDetails;
